import { findAnimationById } from 'Pods/ThreeDStudio/Services/Constants/animations'
import { MATERIAL, PROVIDER } from 'Pods/ThreeDStudio/Store/constants'

/**
 * Returns the value for a schema param from store state.
 * input_image is built as [{ asset_id: inputImage }] when inputImage is set.
 * animation resolves the picked animation slug to the active engine's id.
 * Reads from state.modelSettings (generation params namespace).
 */
export function getStoreValueForParam(schemaKey, settingsKey, state) {
  const settings = state[settingsKey]
  const mapping = {
    prompt: () => settings.prompt,
    face_count: () => settings.targetPolycount,
    target_polycount: () => settings.targetPolycount,
    polygon_type: () => settings.polygonType,
    smart_low_poly: () => settings.isSmartLowPoly,
    ultra_mode: () => settings.extraQuality,
    input_image: () =>
      settings.inputImage != null && settings.inputImage !== ''
        ? [{ asset_id: settings.inputImage }]
        : undefined,
    material: () => settings.material,
    texture_quality: () => settings.textureQuality,
    enable_pbr: () => settings.material === MATERIAL.PBR,
    geometry_only: () => settings.material === MATERIAL.GEOMETRY_ONLY,
    face_level: () => settings.faceLevel,
    input_3d: () => state.viewer.inputThreeD != null && state.viewer.inputThreeD !== ''
      ? [{ asset_id: state.viewer.inputThreeD }]
      : undefined,
    // The Animate tab stores a local library slug; the engines identify the clip
    // differently, so the same schema key resolves to Tripo3D's preset name or
    // Meshy's numeric library id (renamed to action_id by keyToConvert).
    animation: () => {
      const entry = findAnimationById(settings.animationId)

      return state.schema.enhancedProvider === PROVIDER.TRIPO3D
        ? entry?.tripoPreset
        : entry?.actionId
    },
  }
  const mappedFunction = mapping[schemaKey]
  return mappedFunction ? mappedFunction() : undefined
}
